Drupal.behaviors.amrestAnimations = {
  attach: function (context, settings) {
    once('amrestStoreCounter', '.js-global-counter', context).forEach(function (element) {
      const countriesRows = element.querySelectorAll('.js-country-container .js-brand-country');
      const restaurantsEquity = element.querySelectorAll('.js-country-container .js-brand-equity');
      const restaurantsFranchises = element.querySelectorAll('.js-country-container .js-brand-franchise');
      const restaurantsOverall = restaurantsEquity + restaurantsFranchises;
      let restaurantsNumber = 0; //Array.from(restaurantsOverall).reduce((sum, currentNode) => sum + parseInt(currentNode.textContent));
      for (const node of restaurantsEquity) {
        restaurantsNumber += parseInt(node.textContent);
      }
      for (const node of restaurantsFranchises) {
        restaurantsNumber += parseInt(node.textContent);
      }
      const countriesNumber = countriesRows.length;
      // console.log(countriesRows.textContent);
      // console.log(countriesNumber);
      // console.log(restaurantsNumber);
      const countriesNumberHolder = element.querySelector('.js-all-countries');
      const restaurantsNumberHolder = element.querySelector('.js-all-restaurants');
      countriesNumberHolder.textContent = countriesNumber;
      restaurantsNumberHolder.textContent = restaurantsNumber;

      element.classList.add('d-block');
    });
  },
};
